module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: ['ui-tab-list']
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      class: ['ui-tab-list__item', _vm.active === index ? 'active' : '']
    }, [_c('a', {
      class: ['ui-tab-list__item__button'],
      attrs: {
        "href": tab.href
      },
      on: {
        "click": function () { return _vm.handleClick(tab); }
      }
    }, [_c('span', [_vm._v(_vm._s(tab.title))])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c977e2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/UiTabList.vue
// module id = 459
// module chunks = 1